<template>
  <div class="main-in">
    <div class="container" v-cloak>
      <!-- 面包屑 -->
      <div is="titlebox" :nav='JSON.parse(nav)'></div>

      <!-- 内容区 -->
      <div class="content min-h">
        <!-- 搜索筛选行 -->
        <div class="filter-row">
          <span class="filter-label">批次：</span>
          <select v-model="queryParam.batchId" @change="searchQuery">
            <option value="">全部</option>
            <option v-for="item in batchList" :key="item.id" :value="item.id">{{ item.batchName }}</option>
          </select>
          <span class="filter-label">姓名：</span>
          <input type="text" v-model="queryParam.name" placeholder="请输入博士姓名" @keyup.enter="searchQuery">
          <span class="filter-label">主要研究领域：</span>
          <input type="text" v-model="queryParam.researchArea" placeholder="请输入主要研究领域" @keyup.enter="searchQuery">
          <button class="btn-search" @click="searchQuery">查询</button>
        </div>

        <!-- 5列卡片网格 -->
        <div class="card-grid">
          <div class="doctor-card" v-for="item in dataList" :key="item.id" @click="goDetail(item)">
            <div class="card-img-wrap">
              <img v-if="item.photo" :src="$imgUrl + '/' + item.photo" class="card-img-tag">
              <img v-else src="@/assets/img/noheader.jpg" class="card-img-tag">
            </div>
            <div class="card-name">{{ item.name }}</div>
            <div class="card-unit">{{ item.workUnit || '' }}</div>
            <div class="card-batch-tag" v-if="item.batchName">{{ item.batchName }}</div>
          </div>

          <!-- 空状态 -->
          <div v-if="dataList.length === 0 && !loading" class="empty-state">暂无数据</div>
        </div>

        <!-- 分页 -->
        <div class="block">
          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="ipagination.current"
              :page-size="ipagination.pageSize"
              layout="prev, pager, next, jumper"
              :total="ipagination.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoctorList',
  computed: {
    nav() {
      return JSON.stringify([
        { label: '历批次来青博士服务团成员风采展示(持续更新中)', path: '/doctor', type: 0 }
      ])
    },
  },
  data() {
    return {
      batchList: [],
      batchMap: {},
      dataList: [],
      loading: false,
      queryParam: { batchId: '', name: '' },
      ipagination: {
        current: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  mounted() {
    this.$util.goTop()
    this.loadBatchList()
    this.loadData()
  },
  methods: {
    loadBatchList() {
      this.$get('/web/doctor/batchList').then(res => {
        if (res.success) {
          this.batchList = res.result || []
          const map = {}
          this.batchList.forEach(item => { map[item.id] = item.batchName })
          this.batchMap = map
        }
      })
    },
    loadData() {
      this.loading = true
      const params = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      }
      if (this.queryParam.batchId) params.batchId = this.queryParam.batchId
      if (this.queryParam.name) params.name = this.queryParam.name
      if (this.queryParam.researchArea) params.researchArea = this.queryParam.researchArea
      this.$get('/web/doctor/list', params).then(res => {
        if (res.success) {
          this.dataList = res.result.records || []
          this.ipagination.total = res.result.total || 0
        }
      }).finally(() => { this.loading = false })
    },
    searchQuery() {
      this.ipagination.current = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.$util.goTop()
      this.ipagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.$util.goTop()
      this.ipagination.current = val
      this.loadData()
    },
    goDetail(item) {
      this.$router.push({ path: '/doctorDetail', query: { id: item.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.container { background: #ffffff; }

.content {
  width: 100%;
  box-sizing: border-box;
  padding: 30px 50px 50px;
}

/* 搜索筛选行 */
.filter-row {
  display: flex; align-items: center; gap: 12px;
  margin-bottom: 34px; padding-bottom: 18px;
  border-bottom: 1px solid #EBEBEB;
}
.filter-row .filter-label { font-size: 15px; color: #666; white-space: nowrap; }
.filter-row select {
  height: 36px; padding: 0 12px; border: 1px solid #D9D9D9;
  border-radius: 4px; font-size: 14px; color: #333; background: #fff;
  min-width: 160px; outline: none; cursor: pointer; box-shadow: none;
}
.filter-row input {
  height: 36px; padding: 0 12px; border: 1px solid #D9D9D9;
  border-radius: 4px; font-size: 14px; color: #333; width: 200px; outline: none; box-shadow: none;
}
.filter-row input:focus, .filter-row select:focus { border-color: #BA0711; outline: none; }
.filter-row .btn-search {
  height: 36px; padding: 0 24px; background: #BA0711; color: #fff;
  border: none; border-radius: 4px; font-size: 14px; cursor: pointer;
  outline: none;
}
.filter-row .btn-search:hover { background: #990d11; }

/* 卡片网格 */
.card-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px 20px;
}
.doctor-card {
  background: #fafafa; border: 1px solid #eee; border-radius: 8px;
  cursor: pointer; transition: transform 0.2s; text-align: center;
  padding: 18px 10px 14px;
}
.doctor-card:hover { transform: translateY(-4px); box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
.doctor-card .card-img-wrap {
  width: 160px; height: 160px; border-radius: 50%; overflow: hidden;
  margin: 0 auto 10px; border: 3px solid #f0e9e9;
}
.doctor-card .card-img-tag {
  width: 100%; height: 100%; object-fit: cover;
}
.doctor-card .card-batch-tag {
  display: inline-block; background: #BA0711; color: #fff;
  font-size: 12px; padding: 2px 14px; border-radius: 3px;
  margin-top: 6px;
}
.doctor-card .card-name {
  font-size: 18px; font-weight: bold; color: #222; margin-bottom: 2px;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.doctor-card .card-unit {
  font-size: 13px; color: #888; line-height: 1.5; height: 39px;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
  overflow: hidden; word-break: break-all; padding: 0 4px;
}

.empty-state {
  grid-column: 1 / -1; text-align: center; padding: 80px 0;
  color: #999; font-size: 16px;
}

/* 分页 */
.block { text-align: center; margin-top: 40px; margin-bottom: 30px; }
</style>
